var Cart = {
	init:function(){
		$(".coupon-title").on("click touchend", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}
			
			
			if($(".coupon-container").hasClass("open")){
				Cart.close_coupon();
			}else{
				Cart.open_coupon();
			}
			
		})
	},
	open_coupon:function(){
		$(".coupon-container").addClass("open");
		
		var _h = $('.coupon-container .coupon-form').height();
		
		$('.coupon-container .coupon-content').css({height:_h});
		
	},
	close_coupon:function(){
		$(".coupon-container").removeClass("open");
		
		$('.coupon-container .coupon-content').css({height:0});
	}
	
}

$(window).load(function(){
	if($(".woocommerce-cart").length){
		Cart.init();
	}
})